import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
// import { HighlightOff } from "@mui/icons-material";
// import { IconButton } from "@mui/material";
// import { useStyles } from "../../../../util/TableStyles";
import { FeatureService } from "../../../../services/FeatureService";

moment.locale('es');

export const useFeaturesTable = (changeAlert: ChangeAlertCallbackType) => {
    // const clasess = useStyles();
    const [data, setData] = useState([]);
    const [uuid, setUuid] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [filters, setFilters] = useState({});
    const featureService = useRef<FeatureService>();

    const saveData = async (result) => {
        setLoading(true);       
        setData(result.content || []);
        setTotalRows(result.pagination?.total_documents || 0);
        setLoading(false);
    };

    const getData = async (newPage, newPerPage=perPage, filters=null) => {        
        setLoading(true);
        let request = {
            data: {
                page_number: newPage,
                results_per_page: newPerPage
            }
        }
        
        if(filters && Object.values(filters)[0]){
            request.data["filters"] = filters
        }

        const response = await featureService.current.featureList(request)
        setPage(newPage)
        setData(response.data.widget[0].data.content || []);
        setTotalRows(response.data.widget[0].data.pagination?.total_documents || 0);
        setLoading(false);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage)
        getData(newPage, perPage, filters ? filters : null)
    };
    const handlePerRowsChange = async (newPerPage, newPage) => {
        setPage(newPage)
        setPerPage(newPerPage);
        getData(newPage, newPerPage);
    };

    const changeValueSearch = (type, e) => {
        let f = filters
        f[type] = e.target.value.trimStart();
        setSearch(e.target.value.trimStart());
        type === 'uuid' ? delete f['feature_name'] : delete f['uuid']
        setFilters(f);
    };

    const featureSearch = () => {
        getData(1, perPage, filters);
    }
    const reset = () => {
        setSearch('')
        setFilters({})
        setPage(1)
        getData(1, perPage)
    }
 
    useEffect(() => {
        setSearch('')
        setUuid([])
        console.log(search)
        featureService.current = new FeatureService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => row.uuid, name: "UUID", wrap: true, width: "30%" },
            { selector: (row) => row.feature_name, name: "Nombre", wrap: true, width: "30%" },
            { selector: (row) => row.feature_description, name: "Descripción", wrap: true, width: "30%" },
            // { cell: (row) => {
            //     return (
            //       <IconButton title="Remover beneficio" className={clasess.buttonAdd} onClick={removeFeature.bind(this, row, uuid)}>
            //         <HighlightOff />
            //       </IconButton>
            //     )},
            //    width:"7%", wrap: true, sortable: true
            // },
        ]
        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid])

    return { columns: calculateColumns, data, loading, filters, page, perPage, totalRows, reset, featureSearch, changeValueSearch, saveData, getData, handlePageChange, handlePerRowsChange}

}
